type TimecardWithJobTypes = {
  jobs?: Array<{ job_type: string }> | null;
};

/**
 * Checks if a timecard has any Time Off jobs
 * @param timecard - The timecard to check
 * @returns true if the timecard contains any jobs with job_type === 'time_off'
 */
export const hasTimeOffJobs = (timecard: TimecardWithJobTypes): boolean => {
  return timecard.jobs?.some((job) => job.job_type === 'time_off') || false;
};
